var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.33331H0V8.66665H2V7.33331Z",
    fill: "#FF8A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81438 1.87165L1.87158 2.81445L3.28578 4.22865L4.22858 3.28585L2.81438 1.87165Z",
    fill: "#FF8A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 0H7.3335V2H8.66683V0Z",
    fill: "#FF8A00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1852 1.87151L11.771 3.28571L12.7138 4.22851L14.128 2.81431L13.1852 1.87151Z",
    fill: "#FF8A00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.33331H14V8.66665H16V7.33331Z",
    fill: "#FF8A00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7143 11.7714L11.7715 12.7142L13.1857 14.1284L14.1285 13.1856L12.7143 11.7714Z",
    fill: "#FF8A00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 14H7.3335V16H8.66683V14Z",
    fill: "#FF8A00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28578 11.7715L1.87158 13.1857L2.81438 14.1285L4.22858 12.7143L3.28578 11.7715Z",
    fill: "#FF8A00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 12.6666C10.5775 12.6666 12.6668 10.5773 12.6668 7.99998C12.6668 5.42265 10.5775 3.33331 8.00016 3.33331C5.42283 3.33331 3.3335 5.42265 3.3335 7.99998C3.3335 10.5773 5.42283 12.6666 8.00016 12.6666Z",
    fill: "#FF8A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.578d45d46d116ffceb46e9236c6ef7c2.svg";
export { ForwardRef as ReactComponent };